'use client'

import { useEffect, useMemo, useState, type ReactNode } from 'react'
import { mergeQueryParams } from '@/lib/append-query-params'

type ActionLinkProps = {
  baseHref: string
  queryParameters?: string | null
  className?: string
  children: ReactNode
}

export function ActionLink({ baseHref, queryParameters, className, children }: ActionLinkProps) {
  const fallbackHref = useMemo(
    () => mergeQueryParams(baseHref, queryParameters),
    [baseHref, queryParameters],
  )
  const [href, setHref] = useState(fallbackHref)

  useEffect(() => {
    if (typeof window === 'undefined') return

    setHref(mergeQueryParams(baseHref, queryParameters, window.location.search))
  }, [baseHref, queryParameters])

  return (
    <a href={href || '#'} className={className}>
      {children}
    </a>
  )
}
